





























import Vue, { PropType } from 'vue';
import { Option } from 'mostra';

export default Vue.extend({
  name: 'GFontFormInput',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    valid: { type: Boolean as PropType<boolean>, default: true },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    label: { type: String as PropType<string>, default: '' },
    itemComment: { type: Array as PropType<string[]>, default: () => [] },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: true },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    selectedValue: { type: Number as PropType<number>, default: 1 },
    name: { type: String as PropType<string>, default: '' },
    fontOptions: { type: Array as PropType<Option[]>, default: () => [] },
  },
});
